<div class="modal-icon">
    <span
        class="icon"
        hamIconShapes
        icon="assets/hamIcons/trash-outline.svg"
        [variant]="'transparent'"
        [size]="'regular'"
        [type]="'circle'"
    ></span>
</div>

<p>{{ 'aumico_reports_fcp_closing_process_checklist_delete_checklist' | i18next }}</p>
